<template>
    <div class="countdown">
        <span v-if="days > 0">{{ days }}{{$t('purchaseOrder_days')}}</span>
        <span>{{ hours }}</span>:
        <span>{{ minutes }}</span>:
        <span>{{ seconds }}</span>
    </div>
</template>

<script>
    export default {
        props: {
            // 截止时间戳（单位：毫秒）
            endTime: {
                type: Number,
                required: true
            }
        },

        data() {
            return {
                remainingTime: 0,  // 剩余时间（秒）
                timer: null
            }
        },

        computed: {
            // 计算天、小时、分钟、秒
            days() {
                return Math.floor(this.remainingTime / 86400)
            },
            hours() {
                return Math.floor((this.remainingTime % 86400) / 3600).toString().padStart(2, '0')
            },
            minutes() {
                return Math.floor((this.remainingTime % 3600) / 60).toString().padStart(2, '0')
            },
            seconds() {
                return Math.floor(this.remainingTime % 60).toString().padStart(2, '0')
            }
        },

        mounted() {
            this.startCountdown()
        },

        beforeDestroy() {
            //console.log('已销毁')
            this.clearTimer()
        },

        methods: {
            startCountdown() {
                this.updateRemainingTime()
                this.timer = setInterval(() => {
                    this.updateRemainingTime()
                }, 1000)
            },

            updateRemainingTime() {
                const now = Math.floor(Date.now() / 1000) // 当前时间戳（秒）
                const end = Math.floor(this.endTime / 1000) // 截止时间戳（秒）
                const diff = end - now

                if (diff > 0) {
                    this.remainingTime = diff
                } else {
                    this.remainingTime = 0
                    this.clearTimer()
                    this.$emit('end') // 触发结束事件
                }
            },

            clearTimer() {
                if (this.timer) {
                    clearInterval(this.timer)
                    this.timer = null
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .countdown {
        /*font-family: monospace;*/
        font-size: 16px;
        font-weight: 700;
        color: #fa5050;
    }
</style>